export default __webpack_public_path__ + "static/media/4.4426dff4.jpg";